import { RouteObject } from 'react-router-dom';
import React from 'react';
import { PathUtil } from '../util/PathUtil';
import { CspPath } from '../../../CspPath';

const lazyLoadPages: () => Promise<typeof import('./QuestionnairePages')> = () =>
  import(/* webpackPrefetch: true */ './QuestionnairePages');

const QuestionnaireListPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.QuestionnaireListPage,
  })),
);

const QCompilationQuestionnaireListPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.QCompilationQuestionnaireListPage,
  })),
);

const QuestionnaireResponseListPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.QuestionnaireResponseListPage,
  })),
);

const QuestionnaireResponseDrawerContainer = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.QuestionnaireResponseDrawerContainer,
  })),
);

const QuestionnaireDataChangeDrawerContainer = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.QuestionnaireDataChangeDrawerContainer,
  })),
);

const QuestionnaireMissedReasonDrawerContainer = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.QuestionnaireMissedReasonDrawerContainer,
  })),
);

const QCompilationQuestionnaireResponseListPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.QCompilationQuestionnaireResponseListPage,
  })),
);

export const QuestionnaireRoutes: RouteObject[] = [
  {
    path: '',
    element: <QuestionnaireListPage />,
  },
  // ClinRO Compilation in Questionnaire List
  {
    path: PathUtil.toRelativePath(
      CspPath.PATIENT_QUESTIONNAIRE_LIST,
      CspPath.PATIENT_QUESTIONNAIRE_LIST_COMPILE_QUESTIONNAIRE_RESPONSE,
      true,
    ),
    element: <QCompilationQuestionnaireListPage />,
  },
  // Questionnaire Response List
  {
    path: PathUtil.toRelativePath(
      CspPath.PATIENT_QUESTIONNAIRE_LIST,
      CspPath.PATIENT_QUESTIONNAIRE_RESPONSE_LIST,
      true,
    ),
    element: <QuestionnaireResponseListPage />,
    children: [
      // Questionnaire Response
      {
        path: PathUtil.toRelativePath(
          CspPath.PATIENT_QUESTIONNAIRE_RESPONSE_LIST,
          CspPath.PATIENT_QUESTIONNAIRE_RESPONSE_LIST_SELECTED_RESPONSE,
          true,
        ),
        element: <QuestionnaireResponseDrawerContainer />,
      },
      {
        path: PathUtil.toRelativePath(
          CspPath.PATIENT_QUESTIONNAIRE_RESPONSE_LIST,
          CspPath.PATIENT_QUESTIONNAIRE_RESPONSE_LIST_EDIT_RESPONSE,
          true,
        ),
        element: <QuestionnaireDataChangeDrawerContainer />,
      },
      {
        path: PathUtil.toRelativePath(
          CspPath.PATIENT_QUESTIONNAIRE_RESPONSE_LIST,
          CspPath.PATIENT_QUESTIONNAIRE_RESPONSE_LIST_ADD_MISSED_REASON,
          true,
        ),
        element: <QuestionnaireMissedReasonDrawerContainer />,
      },
    ],
  },
  // ClinRO Compilation in Questionnaire Response List
  {
    path: PathUtil.toRelativePath(
      CspPath.PATIENT_QUESTIONNAIRE_LIST,
      CspPath.PATIENT_QUESTIONNAIRE_RESPONSE_LIST_COMPILE_QUESTIONNAIRE_RESPONSE,
      true,
    ),
    element: <QCompilationQuestionnaireResponseListPage />,
  },
];
